// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1vuG_","label":"Labeled_label__3oIJ3","divider":"Labeled_divider__15doE"};